
    var riot = require('riot')
    
riot.tag2('formdatetime', '<div class="row"> <div class="col-xs-8"> <forminput label="{opts.label}" value="{val}" name="{opts.name}" placeholder="{opts.placeholder}" buttonafter="&lt;i class=\'fa fa-calendar\'&gt;&lt;/i&gt;" width1="{opts.width1}" width2="{opts.width2}" buttonafterclick="{showcal}" onupdate="{handleTyping}"></forminput> <popover title="{opts.title}"> <datepicker onupdate="{parent.handleUpdate}" date="{parent.date}"></datepicker> </popover> </div> <div class="col-xs-2 hours"> <select value="{hour}" onchange="{handleHour}" class="form-control"> <option each="{hour in hours}" value="{+hour}">{hour}</option> </select> </div> <div class="col-xs-2 minutes"> <select value="{minute}" onchange="{handleMinute}" class="form-control"> <option each="{minute in minutes}" value="{+minute}">{minute}</option> </select> </div> </div>', 'formdatetime .fa.fa-calendar{ -webkit-pointer-events:none; -moz-pointer-events:none; pointer-events:none; } formdatetime .col-xs-2.hours,formdatetime .col-xs-2.minutes{ position:relative; padding-left:50px; } formdatetime .col-xs-2.hours:after,formdatetime .col-xs-2.minutes:after{ position:absolute; top:10px; left:0px; font-size:12px; } formdatetime .col-xs-2.hours:after{ content:"Hours" } formdatetime .col-xs-2.minutes:after{ content:"Minutes" }', '', function(opts) {
var Formatter, i, results;

Formatter = require('riot-kit/utils/dateformat.coffee');

this.val = "";

this.prevValue = "";

this.hours = (function() {
  results = [];
  for (i = 0; i < 24; i++){ results.push(i); }
  return results;
}).apply(this).map(function(v) {
  if (("" + v).length < 2) {
    return "0" + v;
  } else {
    return "" + v;
  }
});

this.minutes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(function(v) {
  if (("" + v * 5).length < 2) {
    return "0" + v * 5;
  } else {
    return "" + v * 5;
  }
});

this.hour = 8;

this.minute = 0;

this.on('update', function() {
  if (opts.value && this.prevValue !== opts.value.getTime()) {
    this.setDate(opts.value);
    return this.date = opts.value;
  }
});

this.showcal = (function(_this) {
  return function(e) {
    return _this.tags.popover.clicked(e);
  };
})(this);

this.handleUpdate = (function(_this) {
  return function(newdate, changetypes) {
    if (changetypes.indexOf('month') !== -1 || changetypes.indexOf('year') !== -1) {
      return;
    }
    newdate = new Date(newdate.setHours(_this.hour, _this.minute, 0, 0));
    _this.setDate(newdate);
    _this.updateParent(newdate, 1);
    _this.tags.popover.hide();
    return _this.update();
  };
})(this);

this.handleHour = (function(_this) {
  return function(e) {
    _this.hour = e.target.value;
    return setTimeout(function() {
      return _this.updateParent(opts.value);
    });
  };
})(this);

this.handleMinute = (function(_this) {
  return function(e) {
    _this.minute = e.target.value;
    return setTimeout(function() {
      return _this.updateParent(opts.value);
    });
  };
})(this);

this.handleTyping = (function(_this) {
  return function(data) {
    var dt, newdate;
    dt = new Formatter();
    newdate = dt.parseString(opts.dateformat, data.value);
    if (newdate) {
      _this.date = newdate;
      _this.updateParent(newdate, 2);
      return _this.update();
    }
  };
})(this);

this.updateParent = (function(_this) {
  return function(newdate, type) {
    var name;
    if (opts.onupdate && newdate) {
      newdate = new Date(newdate.setHours(_this.hour, _this.minute, 0, 0));
      name = (opts.id != null) && opts.id.length ? opts.id : opts.name;
      _this.prevValue = newdate.getTime();
      return opts.onupdate.call(null, {
        name: name,
        value: newdate
      });
    }
  };
})(this);

this.setDate = (function(_this) {
  return function(date) {
    var dt;
    _this.prevValue = date.getTime();
    if (date) {
      _this.hour = date.getHours();
    }
    if (date) {
      _this.minute = date.getMinutes();
    }
    if (!opts.dateformat || !date) {
      return _this.val = date;
    } else {
      dt = new Formatter(date);
      return _this.val = dt.format(opts.dateformat);
    }
  };
})(this);
});
    
  